import { useEffect } from 'react';

import { useGetContext } from '../../api/lending/lapiHooks';
import {
  CHECKOUT_BASE_PATH,
  SECURITY_CHECKS_BASE_PATH,
} from '../Checkout/routes';
import { buildQueryString } from '../utils/queryParams';

export const redirectToAccountPages = () => {
  const queryString = buildQueryString();

  window.location.href = `/my_account/${queryString}`;
};

export const redirectToCheckout = () => {
  const queryString = buildQueryString();

  window.location.href = `${CHECKOUT_BASE_PATH}/${queryString}`;
};

export const redirectToSecurityChecks = () => {
  const queryString = buildQueryString();

  // todo make this useNavigate
  window.location.href = `${SECURITY_CHECKS_BASE_PATH}/${queryString}`;
};

export function useRedirectToAccountPages() {
  const { context } = useGetContext();

  useEffect(() => {
    if (context.user_signup_finished) {
      redirectToAccountPages();
    }
  }, [context.user_signup_finished]);
}
